import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import useStyles from './useStyle'
import SuscriberTable from './TableNavigable/TableNavigable'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import { getOrganizationWithID } from '../../../redux/actions/Organizations'
import { useDispatch } from 'react-redux'
import InfoIcon from '@mui/icons-material/Info'

export default function Suscribers () {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const [organization, setorganization] = useState(null)

  // get user info request
  const handleGetOrganizationWithID = async () => {
    const response = await dispatch(getOrganizationWithID(id))
    if (response) {
      setorganization(response)
    }
  }

  // get organinzation details of reducer
  useEffect(async () => {
    setLoading(true)
    await handleGetOrganizationWithID()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent
        name={organization ? organization.organizationName : ''}
      />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Suscriptores asociados a una organización
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los suscriptores de la organización{' '}
          {organization ? organization.organizationName : ''}.
        </Typography>
      </div>

      <div className={classes.boxTable}>
        <SuscriberTable
          id={id}
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
